import { StyledSimpleCard } from 'styles';
import { AddServiceToRealmForm } from './AddServiceToRealmForm';

export const AddServiceToRealmCard = () => {
  return (
    <StyledSimpleCard>
      <AddServiceToRealmForm />
    </StyledSimpleCard>
  );
};
